var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout",class:_vm.pageClass},[_c('a-config-provider',{attrs:{"locale":_vm.getAntdLocale(_vm.AppConfig.AppSettings.language)}},[_c(_vm.layout,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }